// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IKTs","toggle":"styles_toggle__3dQUt","preview":"styles_preview__2K_AL"};